import { Link } from "react-router-dom";
import logoWordmark from "../assets/logo-wordmark.png";
import logoWordmarkDark from "../assets/logo-wordmark-dark.png";
import { ThemeToggle } from "./ThemeToggle";

export const Wordmark = ({ className = "", testId }) => (
  <>
    <img src={logoWordmark} alt="infoSociete.com" data-testid={testId} className={`${className} dark:hidden`} />
    <img src={logoWordmarkDark} alt="" aria-hidden="true" className={`${className} hidden dark:block`} />
  </>
);

export const Logo = ({ className = "" }) => (
  <Link to="/" data-testid="logo-link" className={`group flex items-center ${className}`}>
    <Wordmark className="h-8 w-auto object-contain transition-opacity group-hover:opacity-85" />
  </Link>
);

export const Header = () => (
  <header className="no-print sticky top-0 z-40 border-b border-border bg-[hsl(var(--background))]/95 backdrop-blur-sm">
    <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-5">
      <Logo />
      <nav className="flex items-center gap-4 text-sm text-[hsl(var(--fg-secondary))] sm:gap-6">
        <Link to="/" data-testid="nav-home" className="hidden transition-colors hover:text-[hsl(var(--brand))] sm:inline">
          Rechercher
        </Link>
        <span className="hidden rounded-full border border-border bg-[hsl(var(--surface))] px-3 py-1 text-xs font-medium text-[hsl(var(--fg-muted))] sm:inline">
          Service privé
        </span>
        <ThemeToggle />
      </nav>
    </div>
  </header>
);

export const Footer = () => (
  <footer className="no-print mt-20 border-t border-border bg-[hsl(var(--surface))]">
    <div className="mx-auto max-w-5xl px-5 py-10">
      <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
        <div className="max-w-sm">
          <Logo />
          <p className="mt-3 text-sm leading-relaxed text-[hsl(var(--fg-muted))]">
            InfoSociété est un service privé et indépendant. Il n'est lié à aucune
            administration ni organisme public. Les données proviennent de sources
            publiques officielles.
          </p>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <span className="text-xs uppercase tracking-[0.2em] text-[hsl(var(--fg-muted))]">Informations</span>
          <Link to="/mentions-legales" data-testid="footer-mentions" className="text-[hsl(var(--fg-secondary))] transition-colors hover:text-[hsl(var(--brand))]">
            Mentions légales
          </Link>
          <Link to="/confidentialite" data-testid="footer-confidentialite" className="text-[hsl(var(--fg-secondary))] transition-colors hover:text-[hsl(var(--brand))]">
            Confidentialité
          </Link>
        </div>
      </div>
      <p className="mt-8 border-t border-border pt-5 text-xs text-[hsl(var(--fg-muted))]">
        Source des données : API Recherche d'entreprises (INSEE / RNE), diffusion publique.
        © {new Date().getFullYear()} InfoSociété.
      </p>
    </div>
  </footer>
);

export const Layout = ({ children }) => (
  <div className="App flex min-h-screen flex-col">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

export default Layout;
